// removed by extract-text-webpack-plugin
module.exports = {"content":"c-ShippingCountry__content"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/ShippingCountry/ShippingCountry.scss
// module id = 753
// module chunks = 0